<div class="udex-grid udex-mx-auto udex-pb-4 udex-mb-84">
  <div class="col-12 col-md-10 udex-mx-auto">
    @if ((cartEntryGroups$ | async); as cartEntryGroups) { 
      @if (!cartEntryGroups.length) {
        <ng-container *ngTemplateOutlet="oldProvidedBy"></ng-container>
      } @else {
        <dcp-bundle-provided-by
          [entryGroups]="cartEntryGroups"
          [orderEntries$]="orderEntries$"
          [resetOrderEntries]="true"
          [displayTitle]="false">
          <ng-template #providedOrderEntries let-context>
            <dcp-bundle-order-table
              [entry]="context.entry"
              [collapsable]="context.collapsable"
              [collapsed]="context.collapsed"
              [showPrice]="true"
              [showEditAction]="false"
              [showRemoveAction]="false"
              [componentTexts]="componentTexts"
              [showThankYouWarnings]="true">
            </dcp-bundle-order-table>
          </ng-template>
          <ng-template #groupTotal let-context>
            <dcp-group-total [showDivider]="false" [checkout$]="orderFacade.getOrderDetails()" [providerContract]="context.providerContract">
            </dcp-group-total>
          </ng-template>
          <ng-template #recurringTotal let-context>
            <dcp-recurring-total [checkout$]="orderFacade.getOrderDetails()" [providerContract]="context.providerContract">
            </dcp-recurring-total>
          </ng-template>
          <ng-template #derivatives let-context>
            <dcp-derivative-entry-list
              [derivativeEntries]="
                entryGroupService.getOrderEntriesByBundleType(
                  context.providerContract.entryGroups,
                  entryGroupService.isDerivative
                )
              ">
            </dcp-derivative-entry-list>
          </ng-template>
        </dcp-bundle-provided-by>
      } 
    } @else {
    <ng-container *ngTemplateOutlet="oldProvidedBy"></ng-container>
    }
  </div>
</div>

<ng-template #oldProvidedBy>
  <dcp-provided-by [orderEntries$]="orderEntries$" [resetOrderEntries]="true">
    <ng-template #providedOrderEntries let-context>
      <div class="udex-mt-32 udex-p-32 tile">
        <dcp-order-item [componentTexts]="componentTexts" [orderEntry]="context.entry" [showPrice]="true">
        </dcp-order-item>
      </div>
    </ng-template>
  </dcp-provided-by>
</ng-template>
